'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var svgIcon = require('./svg-icon-501cae97.js');

var CaretDown = function (_a) {
    var dataCy = _a.dataCy, className = _a.className, variant = _a.variant, size = _a.size, svgProps = tslib_es6.__rest(_a, ["dataCy", "className", "variant", "size"]);
    return (React__default.createElement(svgIcon.SvgIcon, tslib_es6.__assign({ viewBox: "0 0 50 28", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", className: className, variant: variant, size: size, "data-cy": dataCy }, svgProps),
        React__default.createElement("defs", null),
        React__default.createElement("g", { id: "Atoms-/-Icons-/-Carat", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            React__default.createElement("path", { d: "M50,3.11111111 C50,3.9375 49.6582031,4.71527778 49.0722656,5.29861111 L27.1972656,27.0763889\n        C26.6113281,27.6597222 25.8300781,28 25,28 C24.1699219,28 23.3886719,27.6597222 22.8027344,27.0763889\n        L0.927734375,5.29861111 C0.341796875,4.71527778 -1.42108547e-14,3.9375 -1.42108547e-14,3.11111111\n        C-1.42108547e-14,1.40972222 1.41601562,0 3.125,0 L46.875,0 C48.5839844,0 50,1.40972222 50,3.11111111 Z", id: "Caret-Down---FontAwesome", fill: "currentColor" }))));
};

exports.CaretDown = CaretDown;
